import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput";

class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.presupuesto.coeficientesue.delete}
                postUrl={api.proyectos.config.presupuesto.coeficientesue.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                missingIdMessage={"Debe seleccionar una fila."}
                successMessage={"El Coeficiente UE ha sido eliminado con éxito."}
                title={"Eliminar Coeficiente UE"}
                buttonTitle={"Eliminar Coeficiente UE"}
                buttonIcon={"fa fa-trash fa-lg"}
                
                saveButton={true}
                closeButton={true}
                saveButtonLabel={"Eliminar"}
                buttonClass={"btn-danger"}
                danger={true}
                className={"ui-modal-dialog ui-modal-md"}
            >
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Coeficiente seleccionado</p>
                        <div className="ui-alert ui-alert-danger">
                            <i className="ti ti-trash" aria-hidden="true"></i>
                            <span>Esta acción eliminará el coeficiente UE seleccionado.</span>
                        </div>
                        <ParadigmaLabeledInput disabled fieldName="nombre" label="Nombre" labelColumns={12} fieldColumns={12} />
                        <ParadigmaLabeledInput disabled type={"number"} fieldName="valor" label="Valor" labelColumns={12} fieldColumns={12} />
                        <ParadigmaLabeledInput disabled type={"textarea"} fieldName="descripcion" label="Descripción" labelColumns={12} fieldColumns={12} />
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_CoeficientesUE/Delete.js